<template>

<div class="page-wrap">发现模块</div>

</template>

<script>

export default {
    name: 'discover'
}

</script>

<style lang="scss" scoped>

$red: #ccc;

.test {
    color: $red
}

</style>



// WEBPACK FOOTER //
// index.vue?6b7af28e